// src/providers/LanguageEffect.tsx
'use client'

import { useEffect } from 'react'
import { useLanguage } from './LanguageProvider'

export const LanguageEffect = () => {
  const { language } = useLanguage()

  useEffect(() => {
    document.documentElement.lang = language
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr'
  }, [language])

  return null
}
